import { render } from "./blacklist.vue?vue&type=template&id=6e6622f6&ts=true"
import script from "./blacklist.vue?vue&type=script&lang=ts"
export * from "./blacklist.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__